import { Observable } from 'rxjs';
import { InfluxQueryOutline, MetricsData } from '@app/driver-metrics/model/driver-metrics.interface';
import { DriverStaticData, DriverStaticPayload } from '@app/driver-metrics/model/driver-static.interface';
import { Injectable } from '@angular/core';
import { AdmResource } from '@app/shared/resources/adm.resouce';
import { PaginationParams } from '@app/driver-metrics/model/driver-metrics-data-source';
import { Building } from '@app/shared/models/building.interface';
import { Pageable } from '@app/shared/models/Pageable.interface';
import { AdmFilterCriteria } from '@app/driver-metrics/timeseries/adm-filter.service';
import { DriverStaticFilterCriteria } from '@app/driver-metrics/static/driver-static-filter.service';
import { subDays } from 'date-fns';
import { TimeUtils } from '@app/shared/utils/time.utils';

@Injectable({
  providedIn: 'root'
})
export class AdmService {
  constructor(private readonly admResource: AdmResource) {}

  getAdmData(
    building: Building,
    filterCriteria: AdmFilterCriteria,
    pagParams: PaginationParams
  ): Observable<Pageable<MetricsData>> {
    // The payload needs to be updated as per selected filter values
    const convertedDate = new Date(
      TimeUtils.toBrowserTimeZone(TimeUtils.setDateAndTime(null, null, building.timeZone), building.timeZone) * 1000
    );
    const payload: InfluxQueryOutline = {
      start: filterCriteria.startDateUTC ? filterCriteria.startDateUTC.getTime() : subDays(convertedDate, 1).getTime(),
      end: filterCriteria.endDateUTC ? filterCriteria.endDateUTC.getTime() : convertedDate.getTime(),
      floorIds: filterCriteria.floorIds,
      tagIds: filterCriteria.tagIds,
      type: 'ACTIVE_ENERGY',
      buildingId: building.id,
      dateInterval: 'YEARLY',
      zoneId: building.timeZone,
      groupBy: 'NODE'
    };
    return this.admResource.getAdmData(payload, pagParams);
  }

  getDriverStaticData(building: Building, filterCriteria: DriverStaticFilterCriteria): Observable<DriverStaticData[]> {
    const payload: DriverStaticPayload = {
      buildingId: building.id,
      floorIds: filterCriteria.floorIds,
      tagIds: filterCriteria.tagIds
    };
    return this.admResource.getDriverStaticData(payload);
  }

  downloadExport(building: Building, filterCriteria: AdmFilterCriteria): Observable<Blob> {
    const convertedDate = new Date(
      TimeUtils.toBrowserTimeZone(TimeUtils.setDateAndTime(null, null, building.timeZone), building.timeZone) * 1000
    );
    const payload: InfluxQueryOutline = {
      start: filterCriteria.startDateUTC ? filterCriteria.startDateUTC.getTime() : subDays(convertedDate, 1).getTime(),
      end: filterCriteria.endDateUTC ? filterCriteria.endDateUTC.getTime() : convertedDate.getTime(),
      floorIds: filterCriteria.floorIds,
      tagIds: filterCriteria.tagIds,
      type: 'ACTIVE_ENERGY',
      buildingId: building.id,
      dateInterval: 'YEARLY',
      zoneId: building.timeZone,
      groupBy: 'NODE'
    };
    return this.admResource.downloadExport(payload);
  }
}
